<template>
  <div>

      <div class="row">
        <div class="col-xs-12">
          <div class="block block-bordered">
            <div class="block block-themed">
            <div class="block-header bg-primary-dark">
                  <ul  class="block-options">
                      <li v-if="flagDisplayOrganization===0">
                          <button type="button" @click="toggleDisplayOrganization()"><i class="fa fa-angle-double-down fa-2x"></i></button>
                      </li>
                      <li v-if="flagDisplayOrganization">
                          <button  type="button" @click="toggleDisplayOrganization()"><i class="fa fa-angle-double-up fa-2x"></i></button>
                      </li>
                  </ul>
              <h2 class="h3 block-title" @click="toggleDisplayOrganization()"><i class="fa fa-industry fa-1x push-5-r "></i>{{profileData.managed_organizations[organizationIndex].organizationName}}</h2>
            </div>

            <div v-if="flagDisplayOrganization" class="block-content">
              <spinner  v-if="organizationIsLoading"></spinner>
              <div v-else>

                <!-- =============================================================== -->
                <!-- Affichage de la section intégrateur -->
                <!-- =============================================================== -->
                <div v-if="flagDisplayIntegratorPanel" class="row">
                  <div class="col-xs-12">
                    <h4 class="font-w300"><i class="fa fa-wrench fa-1x push-5-r "></i> {{ labelTitleIntegratorTools[actualLanguage] }}</h4>
                    <button v-if="organizationModel.integrator_options.activationFlag" @click="toggleIntegratorPanel()" type="button" class="btn btn-success align-right push"><i class="fa fa-close fa-1x push-5-r "></i> {{   labelButtonCloseIntegratorPanel[actualLanguage] }}</button>

                    <integrator-tab-menu :organization="organizationModel" ></integrator-tab-menu>
                  </div>
                </div>

                <!-- =============================================================== -->
                <!-- Affichage du détail de l'organisation-->
                <!-- =============================================================== -->
                <div v-if="(flagDisplayIntegratorPanel==false) && (planTransactionData.transactionStatusCode==='000')" class="row">
                  <div class="col-xs-12">
                    <div class="form-group">
                        <div class="col-xs-12">
                            <h5 class="font-w400">ID:{{ organizationModel.organizationId.substring(5,30)}}</h5>
                        </div>

                        <button v-if="organizationModel.integrator_options.activationFlag" @click="toggleIntegratorPanel()" type="button" class="btn btn-success align-right"><i class="fa fa-wrench fa-1x push-5-r "></i> {{   labelButtonOpenIntegratorPanel[actualLanguage] }}</button>
                    </div>

                    <div class="form-group">
                        <div class="col-xs-12">
                            <label for="register4-firstname">{{ labelTextBoxOrganizationName[actualLanguage] }}</label>
                            <input class="form-control" type="text" v-model="organizationModel.organizationInfo.name" placeholder="Adresse / Address...">
                        </div>
                    </div>

                    <div class="form-group">
                        <div class="col-xs-12">
                            <label for="register4-firstname">{{ labelTextBoxAdress[actualLanguage] }}</label>
                            <input class="form-control" type="text" v-model="organizationModel.organizationInfo.address" placeholder="Adresse / Address...">
                        </div>
                    </div>

                    <div class="form-group">
                        <div class="col-xs-12 col-sm-4">
                            <label for="register4-firstname">{{ labelTextBoxCity[actualLanguage] }}</label>
                            <input class="form-control" type="text" v-model="organizationModel.organizationInfo.city" placeholder="Ville / City...">
                        </div>

                        <div class="col-xs-6 col-sm-4">
                            <label for="register4-firstname">{{labelTextBoxProvince[actualLanguage] }}</label>
                            <input class="form-control" type="text" v-model="organizationModel.organizationInfo.province" placeholder="Province / Province ...">
                        </div>

                        <div class="col-xs-6 col-sm-4">
                            <label for="register4-firstname">{{labelTextBoxCountry[actualLanguage] }}</label>
                            <input class="form-control" type="text" v-model="organizationModel.organizationInfo.country" placeholder="Pays / Country ...">
                        </div>            
                    </div>

                    <div class="form-group">
                        <div class="col-xs-6 col-sm-4">
                            <label for="register4-firstname">{{ labelTextBoxPostalCode[actualLanguage] }}</label>
                            <input class="form-control" type="text" v-model="organizationModel.organizationInfo.postalCode" placeholder="Code postal / Postal code...">
                        </div>

                        <div class="col-xs-12 col-sm-4">
                            <label for="register4-firstname">{{ labelTextBoxPhone[actualLanguage] }}</label>
                            <input class="form-control" type="text" v-model="organizationModel.organizationInfo.phoneNumber" placeholder="555-555-5555">
                        </div>            
                    </div>
                  </div>
                  <div class="col-xs-12"><hr></hr></div>


                    <div class="form-group">
                      <div class="col-xs-12">
                      <h4 class="h2 font-w300">{{ sectionLabelOrganizationManager[actualLanguage] }}</h4>
                      <div class="col-xs-12 col-sm-12">
                      <div class="table-responsive">
                        <table class="table">
                          
                            <thead>
                                <tr>
                                    <th class="text-center" style="width: 100px;">{{ labelSectionContactPersonFirstname[actualLanguage] }}</th>
                                    <th class="text-center" style="width: 100px;">{{ labelSectionContactPersonLastname[actualLanguage] }}</th>
                                    <th class="text-center" style="width: 120px;">{{ labelSectionContactPersonEmail[actualLanguage] }}</th>
                                    <th class="text-center" style="width: 80px;">{{ labelSectionContactPersonPhone[actualLanguage] }}</th>
                                    <th class="text-center" style="width: 50px;">{{ buttonLabelDeleteManager[actualLanguage] }}</th>
                                </tr>
                            </thead>
                            <tbody>   
                                  <tr v-for="(contact,index) in organizationModel.managers">
                                      <td class="text-center" style="width: 100px;">
                                        <input v-model="contact.firstName" class="form-control" type="text"  placeholder="Prénom/Firstname">
                                      </td>
                                      <td class="text-center" style="width: 100px;">
                                        <input v-model="contact.lastName" class="form-control" type="text"  placeholder="Nom/Name">
                                      </td>
                                      <td class="text-center">
                                          <input v-model="contact.email" class="form-control" type="text"  placeholder="Courriel/Email">
                                      </td>
                                      <td class="text-center">
                                          <input v-model="contact.phoneNumber" class="form-control" type="text"  placeholder="Téléphone/Phone number">
                                      </td>
                                      <td class="text-center">
                                          <div class="btn-group">
                                              <button class="btn btn-xs btn-default" type="button" @click="confirmRemoveManager(index)" data-toggle="tooltip" title="Retirer/Remove"><i class="fa fa-times"></i></button>
                                          </div>
                                      </td>
                                  </tr>
                            </tbody>
                        </table>
                        </div>
                        </div>
                        <button type="button" @click="addManager()" class="btn btn-xs push" name="buttonAddPlanItem"><i class="fa fa-plus fa-1x push-5-r "></i>{{ buttonLabelAddOrganizationManager[actualLanguage] }}</button>
                    

                    </div>
                    </div>


                    <div class="col-xs-12 col-sm-12 col-md-12 push-20">
                      <p><button @click="saveOrganizationModifications()" type="button" class="btn btn-success align-right" name="button">
                        <spinner size="small" v-if="organizationIsSaving"></spinner>
                        <span v-else><i class="fa fa-floppy-o fa-1x push-5-r "></i>{{ buttonSaveModifications[actualLanguage] }}</span></button></p>
                    </div>

                    



                    <div v-if="organizationModel.subscription.subscriptionId != 'NONE'" class="col-xs-12 col-sm-12 col-md-12 push-20">

                        <!-- ================================================================= -->
                        <!-- Section d'affichage des détails de l'abonnement de l'organisation -->
                        <!-- ================================================================= -->

                        <div v-if="flagUserAsAdministratorLicence" class="block block-themed block-bordered">
                          <div class="block-header bg-primary-dark">
                                <ul class="block-options">
                                    <li v-if="flagDisplayMySubscription===0">
                                        <button type="button" @click="toggleDisplayMySubscription()"><i class="fa fa-angle-double-down fa-2x"></i></button>
                                    </li>
                                    <li v-if="flagDisplayMySubscription">
                                        <button  type="button" @click="toggleDisplayMySubscription()"><i class="fa fa-angle-double-up fa-2x"></i></button>
                                    </li>
                                </ul>
                            <h2 class="h2 block-title" @click="toggleDisplayMySubscription()">{{ sectionLabelSubscriptionLicense[actualLanguage] }}</h2>
                          </div>

                          <div v-if="flagDisplayMySubscription" class="block-content">
                              <h2 class="h1 font-w300 push">{{organizationModel.subscription.data.organization_plan_description.planInfo.title[actualLanguage]}}</h2>
                              
                              <!-- Section qui affiche les statistiques de consommation, on retire cette section !!! -->
                              <h3 v-if="false" class="font-w300">{{tileLabelConsumptionTitle[actualLanguage]}}</h3>
                              <div v-if="false" class="row">
                                  <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4">
                                      <a class="block block-link-hover2">
                                          <div class="block-content block-content-full bg-success clearfix">
                                              <i class="fa fa-television fa-2x text-white pull-right"></i>
                                              <span class="h4 font-w700 text-white">{{organizationModel.rights.rights.channelLimit.count}}/{{organizationModel.rights.rights.channelLimit.max}}</span>
                                              <span class="h4 text-white-op">{{ tileLabelDevice[actualLanguage] }}</span>
                                          </div>
                                      </a>
                                  </div>


                                  <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4">
                                      <a class="block block-link-hover2">
                                          <div class="block-content block-content-full bg-success clearfix">
                                              <i class="fa fa-envelope fa-2x text-white pull-right"></i>
                                              <span class="h4 font-w700 text-white">{{organizationModel.rights.rights.emailMonthlyLimit.count}}/{{organizationModel.rights.rights.emailMonthlyLimit.max}}</span>
                                              <span class="h4 text-white-op">{{tileLabelEmail[actualLanguage] }}</span>
                                          </div>
                                      </a>
                                  </div>


                                  <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4">
                                      <a class="block block-link-hover2">
                                          <div class="block-content block-content-full bg-success clearfix">
                                              <i class="fa fa-stack-exchange fa-2x text-white pull-right"></i>
                                              <span class="h4 font-w700 text-white">{{organizationModel.rights.rights.smsMonthlyLimit.count}}/{{organizationModel.rights.rights.smsMonthlyLimit.max}}</span>
                                              <span class="h4 text-white-op">{{tileLabelSMS[actualLanguage] }}</span>
                                          </div>
                                      </a>
                                  </div>

                                  <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4">
                                      <a class="block block-link-hover2">
                                          <div class="block-content block-content-full bg-success clearfix">
                                              <i class="fa fa-spinner fa-2x text-white pull-right"></i>
                                              <span class="h4 font-w700 text-white">{{organizationModel.backendConsumption.totalCallsCount}}</span>
                                              <span class="h4 text-white-op">{{tileLabelCallsCount[actualLanguage] }}</span>
                                          </div>
                                      </a>
                                  </div>

                                  <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4">
                                      <a class="block block-link-hover2">
                                          <div class="block-content block-content-full bg-success clearfix">
                                              <i class="fa fa-download fa-2x text-white pull-right"></i>
                                              <span class="h4 font-w700 text-white">{{organizationModel.backendConsumption.totalReadItems}}</span>
                                              <span class="h4 text-white-op">{{tileLabelItemsRead[actualLanguage] }}</span>
                                          </div>
                                      </a>
                                  </div>

                                  <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4">
                                      <a class="block block-link-hover2">
                                          <div class="block-content block-content-full bg-success clearfix">
                                              <i class="fa fa-clock-o fa-2x text-white pull-right"></i>
                                              <span class="h4 font-w700 text-white">{{organizationModel.backendConsumption.totalProcessTime}}</span>
                                              <span class="h4 text-white-op">{{tileLabelProcessTime[actualLanguage] }}</span>
                                          </div>
                                      </a>
                                  </div>
                              </div>
                              


                              <!-- ================================================================= -->
                              <!-- Section d'affichage du détail de la licence Organisation -->
                              <!-- ================================================================= -->
                              
                              <div class="row">
                                <div class="col-xs-12 col-sm-12 col-md-12">
                                  <h3 class="h2 font-w300 push">{{ sectionLabelLicenceOrganization[actualLanguage] }}</h3>
                                </div>

                                <div class="col-xs-12 col-sm-12 col-lg-12">
                                    <div class="block block-bordered">
                                        <div class="block-header bg-gray-lighter">
                                            <ul class="block-options">
                                                <li>
                                                    <button type="button"><i class="fa fa-key"></i></button>
                                                </li>
                                            </ul>
                                            <h3 class="h2 block-title">{{organizationModel.subscription.data.organization_licence.title[actualLanguage]}}</h3>
                                        </div>


                                        <div class="block-content">
                                          <div class="row">

                                          <div class="col-xs-12 col-sm-6 col-lg-6">
                                            <h4 class="h2">Licence ID:{{organizationModel.subscription.subscriptionId.substring(11,30)}}</h4>
                                          </div>
                                          <div class="col-xs-12 col-sm-6 col-lg-6 push">
                                            <h3 class="h2 align-right">{{baseCostLabel[actualLanguage]}} : {{organizationModel.subscription.data.organization_licence.price}} $</h3>
                                          </div>

                                          <div class="col-xs-12">
                                          <table v-if="organizationModel.subscription.data.organization_licence.customizedOptions.length > 0">
                                              <thead>
                                                  <tr>
                                                      <th class="text-center" style="width: 25%;">{{selectPlanOptionColumnTitle01[actualLanguage]}}</th>
                                                      <th class="text-center" style="width: 55%;">{{selectPlanOptionColumnTitle02[actualLanguage]}}</th>
                                                      <th class="text-center" style="width: 20%;">{{selectPlanOptionColumnTitle03[actualLanguage]}}</th>
                                                  </tr>
                                              </thead>
                                              <tbody>   
                                                    <tr v-for="(licenceOption,index) in organizationModel.subscription.data.organization_licence.customizedOptions">
                                                        <td class="text-center">{{licenceOption.title[actualLanguage]}}.  {{licenceOption.priceDescription[actualLanguage]}}:{{licenceOption.price}} $ </td>
                                                        <td class="text-center">{{licenceOption.description[actualLanguage]}}</td>

                                                        <td v-if="licenceOption.valueType=='NUMERIC'" class="text-center">
                                                          <h6  class="h6 font-w700 push-10">{{maxValueLabel[actualLanguage]}} </h6>
                                                          <input v-model="licenceOption.value" @change="computeCost()" class="form-control text-center"  placeholder="Valeur/Value">
                                                        </td>
                                                        <td v-if="licenceOption.valueType=='BOOL'" class="text-center">
                                                            <label class="css-input switch switch-success">
                                                              <input type="checkbox" checked v-model="licenceOption.value" @change="computeCost()">
                                                              <span></span> Activation
                                                            </label>                       
                                                        </td>
                                                    </tr>
                                              </tbody>
                                          </table>
                                          </div>
</div>
                                        </div>

                                    </div>
                                </div>
                              </div>
                              


                              <!-- ================================================================= -->
                              <!-- Section d'affichage du détail des licences usagers -->
                              <!-- ================================================================= -->
                              <div class="row">
                                <div class="col-xs-12 col-sm-12 col-md-12">
                                  <h2 class="h2 font-w300 push">{{ sectionLabelLicence[actualLanguage] }}</h2>
                                </div>

                                <div v-if="displayUserLicenceSectionFLag" class="col-sm-12 col-lg-12">
                                    <div v-for ="(userLicence,index) in organizationModel.subscription.data.organization_user_licences" class="block block-bordered">
                                        <div class="block-header bg-gray-lighter">
                                            <ul class="block-options">
                                                <li>
                                                    <button type="button"><i class="fa fa-key"></i></button>
                                                </li>
                                            </ul>
                                            <h3 class="h3 block-title" @click="toggleDisplayUserLicenceFlag(index)">{{userLicence.title[actualLanguage]}} ID: {{userLicence.licenceId.substring(11,30)}}</h3>
                                        </div>
                                        <div v-if="displayUserLicenceFlag[index]" class="block-content">
                                          <div class="col-xs-12 col-sm-12 col-lg-12 push">
                                            <div class="col-xs-12 col-sm-12 col-lg-12 ">
                                              <h3 class="h3 align-right">{{baseCostLabel[actualLanguage]}} : {{userLicence.price}} $</h3>
                                            </div>
                                          </div>
                                          <div class="col-xs-12 col-sm-12 col-lg-12 push">
                                            <div class="col-xs-12 col-sm-6 col-lg-6 ">
                                              <h3 v-if="userLicence.linkedProfile.email != 'NONE'" class="h3 align-left">{{ tableLicenceUser[actualLanguage] }} : {{userLicence.linkedProfile.email}}</h3>
                                              <h3 v-else class="h3 align-left">Disponible/Available</h3>
                                            </div>
                                            <div v-if="userLicence.linkedProfile.email != 'NONE'" class="col-sm-6 col-lg-6 align-right">
                                              <button @click="releaseLicence(index)" class="btn btn-md btn-danger align-right" type="button" title="Retirer/Release"><i class="fa fa-times"></i> {{ buttonLabelRemoveLicence[actualLanguage] }}</button>
                                            </div>
                                            <div v-else class="col-xs-12 col-sm-6 col-lg-6 ">
                                              <button @click="attributeLicence(index)" class="btn btn-md btn-success align-right" type="button" title="Allouer/Attribute"><i class="fa fa-pencil"></i> {{ buttonLabelAllocate[actualLanguage] }}</button>
                                            </div>
                                          </div>

                                          <div v-if="userLicence.linkedProfile.email == 'NONE' && index >= organizationModel.subscription.data.organization_plan_description.planInfo.includedLicence" class="col-sm-12 col-lg-12">
                                              <button @click="deleteLicence(index)" class="btn btn-md btn-danger align-right" type="button" title="Supprimer/Delete"><i class="fa fa-times"></i> {{ buttonLabelDeleteLicence[actualLanguage] }}</button>
                                          </div>
                                          
                                          <table class="table">
                                              <thead v-if="userLicence.customizedOptions.length > 0">
                                                  <tr>
                                                      <th class="text-center" style="width: 25%;">{{selectPlanOptionColumnTitle01[actualLanguage]}}</th>
                                                      <th class="text-center" style="width: 55%;">{{selectPlanOptionColumnTitle02[actualLanguage]}}</th>
                                                      <th class="text-center" style="width: 20%;">{{selectPlanOptionColumnTitle03[actualLanguage]}}</th>
                                                  </tr>
                                              </thead>
                                              <tbody>   
                                                    <tr v-for="(licenceOption,index) in userLicence.customizedOptions">
                                                        <td class="text-center">{{licenceOption.title[actualLanguage]}}.  {{licenceOption.priceDescription[actualLanguage]}}:{{licenceOption.price}} $ </td>
                                                        <td class="text-center">{{licenceOption.description[actualLanguage]}}</td>

                                                        <td v-if="licenceOption.valueType=='NUMERIC'" class="text-center">
                                                          <h6  class="h6 font-w700 push-10">{{maxValueLabel[actualLanguage]}} </h6>
                                                          <input v-model="licenceOption.value" @change="computeCost()" class="form-control text-center"  placeholder="Valeur/Value">
                                                        </td>
                                                        <td v-if="licenceOption.valueType=='BOOL'" class="text-center">
                                                            <label class="css-input switch switch-success">
                                                              <input type="checkbox" checked v-model="licenceOption.value" @change="computeCost()">
                                                              <span></span> Activation
                                                            </label>                       
                                                        </td>
                                                    </tr>
                                              </tbody>
                                          </table>
                                          
                                        </div>
                                    </div>
                                </div>
                              </div>
 

                              <div v-if="organizationModel.subscription.data.organization_plan_description.planInfo.maximumLicenceCount > 1" class="col-sm-12 col-lg-12 push">
                                  <button @click="addUserLicence()" class="btn btn-block btn-success align-center" type="button" title="Ajouter/Add"><i class="fa fa-plus"></i> {{ buttonLabelAddUserLicence[actualLanguage] }}</button>
                              </div>

                              <div class="col-sm-12 col-lg-12 push">
                                <p><button @click="saveLicenceOptionsModifications()" type="button" class="btn btn-block btn-success align-center">
                                  <spinner size="small" v-if="licenceOptionsIsSaving"></spinner>
                                  <span v-else><i class="fa fa-save"></i> {{ buttonSaveLicenceOptions[actualLanguage] }}</span></button></p>
                              </div>




                              <!-- ================================================================= -->
                              <!-- Section cout d'abonnement -->
                              <!-- ================================================================= -->
                              <div class="row">
                                <div class="col-xs-12 col-sm-12 col-md-12">
                                <h2 class="h2 font-w300">{{ sectionLabelSubscriptionFees[actualLanguage] }}</h2>
                                  <div class="col-xm-12">
                                      <a class="block block-link-hover2">
                                          <div class="block-content block-content-full bg-success clearfix">
                                              <i class="fa fa-money fa-2x text-white pull-right"></i>
                                              <span class="h4 text-white-op">{{actualMensualityLabel[actualLanguage]}}:</span>
                                              <span class="h4 font-w700 text-white">{{sumFinalCost}}$</span>
                                          </div>
                                      </a>
                                  </div>

                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th class="text-center" style="width: 75%;">{{actualmensualityDescripCol1[actualLanguage]}}</th>
                                                <th class="text-center" style="width: 25%;">{{actualmensualityDescripCol2[actualLanguage]}}</th>
                                            </tr>
                                        </thead>
                                        <tbody>   
                                              <tr>
                                                  <td class="text-center">Somme des frais de base</td>
                                                  <td class="text-center">{{sumBaseCost}} $</td>
                                              </tr>
                                              <tr>
                                                  <td class="text-center">Rabais de volume</td>
                                                  <td class="text-center">-{{sumRebate}} $</td>
                                              </tr>
                                              <tr v-if="specialRebate>0">
                                                  <td class="text-center">{{specialRebateString}}</td>
                                                  <td class="text-center">-{{specialRebate}} $</td>
                                              </tr>



                                              <tr>
                                                  <td class="text-center">Estimation des frais mensuel</td>
                                                  <td class="text-center">{{sumFinalCost}} $</td>
                                              </tr>
                                        </tbody>
                                    </table>
                                
                                </div>
                              
                                <div class="col-xs-12 col-sm-12 col-md-12">
                                  <h2 class="h2 font-w300">{{ sectionLabelPaymentInfo[actualLanguage] }}</h2>
                                  <organization-payment-info v-bind:organizationData="organizationModel"></organization-payment-info>
                                </div>

                              </div>
                            </div>

                            <div>
                              
                                <p><button @click="subscribeToAdminPlan()" type="button" class="btn btn-success align-right" name="button">{{ buttonLabelModifyMyPackage[actualLanguage] }}</button></p>
                            </div>
                        </div>

                        <div v-else class="col-sm-12 col-md-12 push-20">
                          <h4 class="font-w300">{{ textMessageUserDoNotHaveLicenceToEditOrganization[actualLanguage] }}</h4>
                        </div>

                    </div>


                    <div v-if = "organizationModel.subscription.subscriptionId==='NONE'">
                        <h5 class="push-10">{{ textMessageToAccessMenager[actualLanguage] }}</h5>
                        <p><button @click="subscribeToAdminPlan()" type="button" class="btn btn-success align-right" name="button">{{ buttonLabelSubcribeToPackage[actualLanguage] }}</button></p>
                    </div>


                    <div class="col-xs-12 col-sm-12 col-md-12">
                      <organization-payment-history v-bind:organizationData="organizationModel"></organization-payment-history>
                    </div>

                    <div v-if="organizationModel.apiManagement.apiActivationFlag" class="col-xs-12 col-sm-12 col-md-12">
                      <organization-api-management v-bind:organizationData="organizationModel"></organization-api-management>
                    </div>


                </div>


                <!-- =============================================================== -->
                <!-- Section d'affichage du processus d'achat forfait Administrateur -->
                <!-- Ce code est aussi dans profile/index ligne 333-->
                <!-- =============================================================== -->
                <div v-if= "planTransactionData.transactionStatusCode==='055' || planTransactionData.transactionStatusCode==='065' || planTransactionData.transactionStatusCode==='105'" class="row">
                  <div class="block block-themed">
                    <div class="block-header bg-primary-dark">
                          <ul class="block-options">
                              <li >
                                  <button type="button"><i class="fa fa-angle-double-down fa-2x"></i></button>
                              </li>
                          </ul>
                      <h2 class="block-title" @click="toggleDisplayPlan()">{{labelTitleServicePlanOrganization[actualLanguage]}}</h2>
                    </div>

                    <div class="block-content">
                      <div class="row">
                          <div class="col-sm-12 col-md-12">
                            <admin-plan-table></admin-plan-table>
                          </div>
                      </div>
                    </div>

                    <div  class="row">
                        <div class="col-sm-12 col-md-12">
                          <p><button @click="returnToMyServicePlan()" type="button" class="h2 btn btn-success align-right" name="button">{{labelReturnToMyProfileBtn[actualLanguage]}}</button></p>
                        </div>
                    </div>

                  </div>
                </div>


                <!-- =============================================================== -->
                <!-- Après exécution de la transaction réussie, affichage du message seulement -->
                <!-- Ce code est aussi dans profile/index ligne 368-->
                <!-- =============================================================== -->
                <div v-if="planTransactionData.transactionStatusCode === '999'"  class="row">

                  <div v-if="planTransactionData.postAction === 'NewSubscription'"  class="row">
                      <h4 class="font-w200 text-center">{{labelSubscriptionRecorded[actualLanguage]}}</h4>
                  </div>

                  <div v-if="planTransactionData.postAction === 'NewAdminSubscription'"  class="row">
                      <h4 class="font-w200 text-center">{{labelAdminSubscriptionRecorded[actualLanguage]}}</h4>
                  </div>

                  <div v-if="planTransactionData.postAction === 'ModifyCreditCard'"  class="row">
                      <h4 class="font-w200 text-center">{{labelNewCreditCardRecorded[actualLanguage]}}</h4>
                  </div>

                  <div  class="row">
                      <div class="col-sm-12 col-md-12 push">
                      </div>
                      <div class="col-sm-12 col-md-12 push">
                      </div>
                      <div class="col-sm-12 col-md-12 push">
                      </div>
                      <div class="col-sm-12 col-md-12">
                        <p><button @click="returnToMyServicePlan()" type="button" class="h2 btn btn-success align-right" name="button">{{labelReturnToMyProfileBtn[actualLanguage]}}</button></p>
                      </div>
                  </div>

                </div>



              </div>
            </div>

            </div>



        </div>
      </div>
      </div>
    </div>
  </div>


</template>

<script>

import _ from 'underscore'
import {mapState, mapGetters} from 'vuex'
import Spinner from '@/components/Spinner'
import OrganizationPaymentInfo from './OrganizationPaymentInfo'
import OrganizationPaymentHistory from './OrganizationPaymentHistory'
import OrganizationApiManagement from './OrganizationApiManagement'
import IntegratorTabMenu from './Integrator/IntegratorTabMenu'
import AdminPlanTable from './AdminPlanTable'

export default {
  props: ['organizationIndex'],
  components: {
    Spinner,
    OrganizationPaymentInfo,
    OrganizationPaymentHistory,
    OrganizationApiManagement,
    IntegratorTabMenu,
    AdminPlanTable
  },
  data() {
    return {
      flagDisplayOrganization : 0,
      flagDisplayMySubscription : 0,
      
      organizationIsSaving : false,
      organizationIsLoading : false,
      subscriptionPrice : 0,

      organizationModel: {
        organizationId:'',
        rights:{},
        organizationInfo : {name:'',
                            address:'',
                            city:'',
                            province:'',
                            country:'',
                            postalCode:'',
                            phoneNumber:''},
        managers: [{profileId:'TBD',
                            firstName:'TBD',
                            lastName:'TBD',
                            email:'TBD',
                            phoneNumber:'',
                            mainContactFlag:false}],
        subscription: [],
        licences:[],           

      },
      
      actualLanguage : "FR",
      flagDisplaySelectPlan : false,
      flagUserAsAdministratorLicence : false,

      flagDisplayIntegratorPanel : 0,
      labelButtonOpenIntegratorPanel : {FR: "Outils Intégrateurs", EN: 'Integrator tools'},
      labelButtonCloseIntegratorPanel : {FR: "Fermer", EN: 'Close'},
      labelTitleIntegratorTools : {FR: "Outils Intégrateurs", EN: 'Integrator tools'},


      labelField: {FR: '', EN: ''},
      labelPaymentTerms: {'Month':{FR: "Paiement mensuel", EN: 'Monthly payment'},
                          'Year':{FR: "Paiement annuel", EN: 'Annually payment'},},

      labelTextBoxOrganizationName:{FR: "Nom de l'organisation", EN: 'Organization name'},
      labelTextBoxAdress:{FR: "Adresse", EN: 'Address'},
      labelTextBoxCity:{FR: "Ville", EN: 'City'},
      labelTextBoxProvince:{FR: "Province", EN: 'Province'},
      labelTextBoxCountry:{FR: "Pays", EN: 'Country'},
      labelTextBoxPostalCode:{FR: "Code Postal", EN: 'Postal code'},
      labelTextBoxPhone:{FR: "Numéro téléphone", EN: 'Phone number'},

      sectionLabelOrganizationManager:{FR: "Administateur de l'Organisation", EN: 'Organization Administrator'},
      labelSectionContactPersonFirstname:{FR: "Prénom", EN: 'First name'},
      labelSectionContactPersonLastname:{FR: "Nom", EN: 'Last name'},
      labelSectionContactPersonEmail:{FR: "Courriel", EN: 'Email'},
      labelSectionContactPersonPhone:{FR: "Téléphone", EN: 'Phone number'},
      buttonLabelDeleteManager:{FR: "Retirer", EN: 'Remove'},
      buttonLabelAddOrganizationManager:{FR: "Ajouter un administrateur de l'organisation", EN: 'Add organization administrator'},
      buttonSaveModifications:{FR: "Enregistrer les modifications", EN: 'Save modifications'},
      sectionLabelSubscriptionLicense:{FR: "Abonnement & Licences", EN: 'Subscription & Licenses'},
      tileLabelGroup:{FR: "Groupes", EN: 'Groups'},
      tileLabelSystem:{FR: "Systems", EN: 'Systems'},
      tileLabelDevice:{FR: "Appareils", EN: 'Devices'},
      tileLabelDevicePerSystem:{FR: "Appareils par system", EN: 'Devices per system'},

      tileLabelConsumptionTitle:{FR: "Statistiques d'utilisation (mois en cours)", EN: 'Usage statistics (this month)'},
      tileLabelCallsCount:{FR: "Nombre requêtes", EN: 'Requests count'},
      tileLabelItemsRead:{FR: "Items lus", EN: 'Items read count'},
      tileLabelProcessTime:{FR: "Temps opération", EN: 'Process time'},

      tileLabelEmail:{FR: "Courriel", EN: 'Email'},
      tileLabelSMS:{FR: "SMS", EN: 'SMS'},

      sectionLabelLicenceOrganization:{FR: "Détails du forfait de l'organisation", EN: 'Organization subscription details and options'},
      baseCostLabel:{FR: "Coût de base", EN: 'Base cost'},
      selectPlanOptionColumnTitle01: {FR: "Option", EN: 'Option'},
      selectPlanOptionColumnTitle02: {FR: "Description", EN: 'Description'},
      selectPlanOptionColumnTitle03: {FR: "Activation de l'option / Valeur maximum", EN: 'Option activation / Maximum value'},
      maxValueLabel: {FR: "Valeur maximale (limite)", EN: 'Maximum value (limit)'},
      buttonLabelDeleteLicence: {FR: "Supprimer cette licence", EN: 'Delete this licence'},
      buttonLabelAddUserLicence: {FR: "Ajouter une licence usager", EN: 'Add user licence'},


      sectionLabelLicence:{FR: "Licences usagers", EN: 'Users licenses'},
      tableLicenceType:{FR: "Type", EN: 'Type'},
      tableLicenceUser:{FR: "Utilisateur lié", EN: 'Linked user'},
      tableLicenceAction:{FR: "Action", EN: 'Action'},
      buttonLabelRemoveLicence:{FR: "Retirer", EN: 'Remove'},
      buttonLabelAllocate:{FR: "Allouer la licence", EN: 'Allocate the licence'},
      sectionLabelSubscriptionFees:{FR: "Frais d'abonnement", EN: 'Subscription fees'},

      buttonSaveLicenceOptions:{FR: "Enregistrer mes modifications de licence", EN: 'Save my licences options'},
      actualMensualityLabel:{FR: "Estimation de votre mensualité", EN: 'Estimated monthly fees'},
      actualmensualityDescripCol1:{FR: "Détails", EN: 'Details'},
      actualmensualityDescripCol2:{FR: "Valeur", EN: 'Value'},


      sectionLabelPaymentInfo:{FR: "Information de paiement", EN: 'Payment information'},
      textMessageUserDoNotHaveLicenceToEditOrganization:{FR: "Votre licence d'accèes ne permet pas de modifier les accèes de l'organisation ", EN: 'Your user licence does not allows to edit the organization access.'},
      textMessageToAccessMenager:{FR: "Pour activer la plateforme gestionaire, votre organisation doit adhérer à un forfait.", EN: 'To activate the manager web platform, your organization must subscribe to a package.'},
      buttonLabelSubcribeToPackage:{FR: "Adhérer à un forfait", EN: 'Subscribe to a package'},
      buttonLabelModifyMyPackage:{FR: "Modifier le forfait", EN: 'Modify package'},

      messagePromptNewManagerEmail:{FR: "Inscrire l'adresse courriel de l'utilisateur EV Sens que vous désirez ajouter comme administrateur de l'organisation", EN: 'Write the EV Sens user email that you want to add as organization administrator'},
      messageUserValidationFail:{FR: "Erreur de validation de l'existance de l'usager!", EN: 'User validation error!'},
      messageUserValidationUserDoNotExist:{FR: "L'utilisateur n'existe pas dans le système EV Sens.", EN: 'The user do not exists in the EV Sens system.'},
      messagePostFail:{FR: "Une erreur est survenue pendant l'opération.", EN: 'An error occurs during the operation'},
      messagePromptConfirmManagerRemove:{FR: "Confirmer le retrait de l'administrateur: ", EN: 'Confirm administrator removal:'},
      messagePromptCannotRemoveLastManager:{FR: "Vous ne pouvez pas supprimer le dernier administrateur de l'organisation.", EN: 'You cannot remove the last administrator of the organization.'},

      messagePromptEmailLicenceRecipient:{FR: "Entrer l'adresse courriel de l'utilisateur EV Sens que vous désirez lier à la licence:", EN: 'Write the user email that you want to link to the license:'},
      messageUserAlreadyHaveLicence:{FR: "L'usager détient déjà une licence, il doit la libérer avant de pouvoir lui octroyer!", EN: 'User already had licence, he needs to release it before you can attribute to him!'},
      messagePromptConfirmLicenceRelease:{FR: "Confirmer la relâche de la licence!", EN: 'Confirm licence release!'},
      messagePromptConfirmUserLicenceAdd1:{FR: "Confirmer la création d'une licence usager, cette opération sera enregistrée dans le système et des frais de ",
                                           EN: 'Confirm the user licence creation, this operation is automatically saved in the system so your next monthly payment will have an additionnal '},
      messagePromptConfirmUserLicenceAdd2:{FR: "$ seront ajouté au coût de base (avant rabais) de votre prochaine mensualitée.",
                                           EN: '$ charge on your base cost fees (before rebate application).'},
      messagePromptConfirmLicenceDeleting:{FR: "Confirmer la supression de la licence.",
                                           EN: 'Confirm licence deletion.'},
      sumBaseCost : 0,
      sumRebate : 0,
      specialRebate : 0,
      specialRebateString : "",
      sumFinalCost : 0,
      displayUserLicenceSectionFLag : true,
      displayUserLicenceFlag : [],

      licenceOptionsIsSaving : false,
      flagAdviseUserAboutChangeOptionSave : 0,
      messageYouMustSaveOption:{FR: "Vous pouvez modifer les options afin de visualiser les changements. Pour enregistrer vos options dans le système, vous devez utiliser le bouton : Enregistrer mes modifications de licence",
                                 EN: 'You can modify the licence options to observe fees impacts. To save and confirm your options, use the Save my licence options button'},

      labelTitleServicePlanOrganization: {FR: 'Plan de service pour les organisations', EN: 'Organization service plan'},
      labelReturnToMyProfileBtn: {FR: 'Retour à mon organisation', EN: 'Return to my organization'},


    }
  },
  computed: {
    ...mapState('sessionStore', ['profileData','planTransactionData']),
  },
  watch: {
    profileData(){
        this.getOrganizationData()
    },
  },

  methods: {
  
   toggleDisplayOrganization(){
      this.flagDisplayOrganization = ~this.flagDisplayOrganization

      if(this.flagDisplayOrganization==-1){
          this.getOrganizationData()
      }

    },

    toggleDisplayMySubscription(){
        this.flagDisplayMySubscription = ~this.flagDisplayMySubscription
    },

    toggleIntegratorPanel(){
        this.flagDisplayIntegratorPanel = ~this.flagDisplayIntegratorPanel
    },


    reloadTempoBundle(){
        this.tempoBundle = JSON.parse(JSON.stringify(this.actualBundle))
    },

    toUsername(email) {
      var email2 = email.replace('.', '-dot-')
      email = email2.replace('.', '-dot-')
      email2 = email.replace('.', '-dot-')
      return email2.replace('@', '-at-')
    },

    returnToMyServicePlan(){
      this.planTransactionData.transactionStatusCode = '000'
      //this.flagDisplayPlan = 0
      window.scrollTo(0, 0)
    },

    addManager(){

      var newEmail = prompt(this.messagePromptNewManagerEmail[this.actualLanguage], "@");

      return this.$store.dispatch('sessionStore/validateUserExist',newEmail)
      .then((response) => {
         this.displayMessage = response.data.Message

         if (response.data.Code=='Fail') window.alert(this.messageUserValidationFail[this.actualLanguage])
         if (response.data.Code=='E01') window.alert(this.messageUserValidationUserDoNotExist[this.actualLanguage])
         
         if (response.data.Code=='OK') {
              //this.tempoBundle.alerts[this.alertIndex].AlertData.email_recipient.push(newEmail)
              var requestData = { 'postAction':'AddOrganizationManager',
                                  'organizationId': this.profileData.managed_organizations[this.organizationIndex].organizationId,
                                  'userId':this.toUsername(newEmail)
                                  }
              //console.log(requestData)
              this.$store.dispatch('sessionStore/postOrganization', requestData)
                  .then((response) => {
                  if(response.data.Code=='OK'){
                      this.getOrganizationData()
                      }else{
                        window.alert(response.data.PromptMessage[this.actualLanguage])
                        }
                  })
           }
        })

    },

    confirmRemoveManager(index) {
      var proceedToAction = false

      if(this.organizationModel.managers.length > 1){

          if (window.confirm(this.messagePromptConfirmManagerRemove[this.actualLanguage] + `"${this.organizationModel.managers[index].email}"?`)){
                  proceedToAction = true
              }  
      }else{
            window.alert(this.messagePromptCannotRemoveLastManager[this.actualLanguage])
      }

      if(proceedToAction){
         this.organizationIsSaving = true
          var requestData = { 'postAction':'RemoveOrganizationManager',
                              'organizationId': this.profileData.managed_organizations[this.organizationIndex].organizationId,
                              'managerIndex': index,
                              }     
          this.$store.dispatch('sessionStore/postOrganization', requestData)
              .then((response) => {
                this.organizationIsSaving = false
              if(response.data.Code=='OK'){
                  this.getOrganizationData()
                  }
                  else{
                     window.alert(response.data.PromptMessage[this.actualLanguage])
                     }
              })         
      }
    },



    saveOrganizationModifications() {
        this.organizationIsSaving = true
        var requestData = { 'postAction':'SaveOrganizationModifications',
                            'organizationId': this.profileData.managed_organizations[this.organizationIndex].organizationId,
                            'organizationData': this.organizationModel,
                            }     
        this.$store.dispatch('sessionStore/postOrganization', requestData)
            .then((response) => {
              this.organizationIsSaving = false
            if(response.data.Code=='OK'){
                this.getOrganizationData()
                }
                else{ 
                  window.alert(response.data.PromptMessage[this.actualLanguage])
                  }
            })       
      
    },


    getOrganizationData(){
        this.organizationIsLoading = true
        var requestData = { 'postAction':'ReadOrganizationData',
                            'organizationId': this.profileData.managed_organizations[this.organizationIndex].organizationId,
                            }
        this.$store.dispatch('sessionStore/postOrganization', requestData)
            .then((response) => {
              //console.log('----Organization Data------')
              //console.log(response.data)
            if(response.data.Code=='OK'){
                this.organizationModel = response.data.OrganizationData
                this.displayUserLicenceFlag = []
                if (this.organizationModel.subscription.subscriptionId != 'NONE'){
                  for(var m = 0;m < this.organizationModel.subscription.data.organization_user_licences.length;m++){this.displayUserLicenceFlag.push(0)}
                  this.computeCost()
                }


                this.organizationIsLoading = false
                }else{
                  this.organizationIsLoading = false
                  window.alert(response.data.PromptMessage[this.actualLanguage])}
            })
    },

    toggleDisplayUserLicenceFlag(index){
      this.displayUserLicenceSectionFLag = false
      this.displayUserLicenceFlag[index]=~this.displayUserLicenceFlag[index]
      this.displayUserLicenceSectionFLag = true
    },

    subscribeToAdminPlan(){
      this.planTransactionData.transactionStatusCode = '055'
      this.planTransactionData.postAction = 'NewAdminSubscription'
      this.planTransactionData.organizationId = this.profileData.managed_organizations[this.organizationIndex].organizationId
      this.planTransactionData.organizationSubscription =this.organizationModel.subscription
    },


    addUserLicence(){
      var promptMessage = this.messagePromptConfirmUserLicenceAdd1[this.actualLanguage]
      promptMessage = promptMessage + this.organizationModel.subscription.data.organization_plan_description.userLicenceData.price
      promptMessage = promptMessage + this.messagePromptConfirmUserLicenceAdd2[this.actualLanguage]
      if (window.confirm(promptMessage)){

        var requestData = { 'postAction':'AddUserLicenceToSubscription',
                            'organizationId': this.profileData.managed_organizations[this.organizationIndex].organizationId,
                            'subscriptionId': this.organizationModel.subscription.subscriptionId
                            }
        this.$store.dispatch('sessionStore/processSubscription', requestData)
            .then((response) => {
              //console.log('---------------------------')
              //console.log(response.data)
            if(response.data.Code=='OK'){
                this.organizationModel = response.data.OrganizationData
                this.subscriptionPrice = this.organizationModel.subscription.data.renewalPrice/100
                this.computeCost()
                }else{
                  window.alert(response.data.PromptMessage[this.actualLanguage])}
            })


      }

    },

    saveLicenceOptionsModifications(){
      this.licenceOptionsIsSaving = true

        var requestData = { 'postAction':'SaveLicencesOptionsModifications',
                            'organizationId': this.profileData.managed_organizations[this.organizationIndex].organizationId,
                            'subscriptionId': this.organizationModel.subscription.subscriptionId,
                            'organizationLicence': this.organizationModel.subscription.data.organization_licence,
                            'userLicences': this.organizationModel.subscription.data.organization_user_licences,
                            }
        this.$store.dispatch('sessionStore/processSubscription', requestData)
            .then((response) => {
              //console.log('---------------------------')
              //console.log(response.data)
              this.licenceOptionsIsSaving = false
            if(response.data.Code=='OK'){
                this.organizationModel = response.data.OrganizationData
                this.computeCost()
                }else{
                  window.alert(response.data.PromptMessage[this.actualLanguage])}
            })


    },


    attributeLicence(index){
      var licenceId = this.organizationModel.subscription.data.organization_user_licences[index].licenceId.substring(11,30)
      //var newEmail = prompt(this.messagePromptEmailLicenceRecipient[this.actualLanguage]+`"${index+1}"`, "@");
      var newEmail = prompt(this.messagePromptEmailLicenceRecipient[this.actualLanguage]+licenceId, "@");

      return this.$store.dispatch('sessionStore/validateUserExist',newEmail)
      .then((response) => {
         this.displayMessage = response.data.Message

         if (response.data.Code=='Fail') window.alert(this.messageUserValidationFail[this.actualLanguage])
         if (response.data.Code=='E01' && this.actualLanguage == "FR") window.alert(this.messageUserValidationUserDoNotExist[this.actualLanguage])

         
         //console.log(response.data)
         if (response.data.Code=='OK') {
              //this.tempoBundle.alerts[this.alertIndex].AlertData.email_recipient.push(newEmail)
              if(response.data.UserHadLicenceFlag){
                window.alert(this.messageUserAlreadyHaveLicence[this.actualLanguage])
              }else{
                    var requestData = { 'postAction':'AttributeUserLicence',
                                        'organizationId': this.profileData.managed_organizations[this.organizationIndex].organizationId,
                                        'subscriptionId': this.organizationModel.subscription.subscriptionId,
                                        'userLicenceId': this.organizationModel.subscription.data.organization_user_licences[index].licenceId,
                                        'licenceIndex':index,
                                        'userIdRecipient':this.toUsername(newEmail)
                                        }
                    //console.log(requestData)
                    this.$store.dispatch('sessionStore/processSubscription', requestData)
                        .then((response) => {
                        if(response.data.Code=='OK'){
                            this.getOrganizationData()
                            }else{
                              window.alert(response.data.PromptMessage[this.actualLanguage])
                              }
                        })
                }
           }
        })


    },

    releaseLicence(index){
        var ProceedToAction = false

        if (window.confirm(this.messagePromptConfirmLicenceRelease[this.actualLanguage])){
            ProceedToAction = true
        }

        if(ProceedToAction){
            var requestData = {'postAction':'ReleaseUserLicence',
                                'organizationId': this.profileData.managed_organizations[this.organizationIndex].organizationId,
                                'subscriptionId': this.organizationModel.subscription.subscriptionId,
                                'userLicenceId': this.organizationModel.subscription.data.organization_user_licences[index].licenceId,
                                'licenceIndex':index}
            this.$store.dispatch('sessionStore/processSubscription', requestData)
                .then((response) => {
                this.profileIsSaving = false
                if(response.data.Code=='OK'){
                    this.getOrganizationData()
                    }
                    else{
                      window.alert(response.data.PromptMessage[this.actualLanguage])
                      }
                })
        }
    },


    deleteLicence(index){
        var ProceedToAction = false

        if (window.confirm(this.messagePromptConfirmLicenceDeleting[this.actualLanguage])){
            ProceedToAction = true
        }

        if(ProceedToAction){
            var requestData = {'postAction':'DeleteUserLicence',
                                'organizationId': this.profileData.managed_organizations[this.organizationIndex].organizationId,
                                'subscriptionId': this.organizationModel.subscription.subscriptionId,
                                'userLicenceId': this.organizationModel.subscription.data.organization_user_licences[index].licenceId,
                                'licenceIndex':index}
            this.$store.dispatch('sessionStore/processSubscription', requestData)
                .then((response) => {
                this.profileIsSaving = false
                if(response.data.Code=='OK'){
                    this.getOrganizationData()
                    }
                    else{
                      window.alert(response.data.PromptMessage[this.actualLanguage])
                      }
                })
        }
    },



    computeCost(){

      this.flagAdviseUserAboutChangeOptionSave = this.flagAdviseUserAboutChangeOptionSave + 1
      if((this.flagAdviseUserAboutChangeOptionSave == 2) && (this.sumBaseCost>0)){
        window.alert(this.messageYouMustSaveOption[this.actualLanguage])
      }

      this.sumBaseCost = 0
      this.sumBaseCost += parseFloat(this.organizationModel.subscription.data.organization_licence.price)
      var subscriptionData = this.organizationModel.subscription.data

      for (var n = 0; n < subscriptionData.organization_licence.customizedOptions.length; n++) {
            if(subscriptionData.organization_licence.customizedOptions[n].valueType == 'BOOL' && subscriptionData.organization_licence.customizedOptions[n].value==true){
              this.sumBaseCost += parseFloat(subscriptionData.organization_licence.customizedOptions[n].price)
            }

            if(subscriptionData.organization_licence.customizedOptions[n].optionID == 'ChannelMaxCount'){
              var extraCount = parseFloat(this.organizationModel.rights.rights.channelLimit.count)-parseFloat(subscriptionData.organization_licence.customizedOptions[n].firstNoChargeCountValue)

              if(extraCount>0){
                this.sumBaseCost += parseFloat(subscriptionData.organization_licence.customizedOptions[n].price)*extraCount
              }
              
            }
         }

      
      for (var m = 0; m < subscriptionData.organization_user_licences.length; m++) {
        this.sumBaseCost += parseFloat(subscriptionData.organization_user_licences[m].price)

        for (var n = 0; n < subscriptionData.organization_user_licences[m].customizedOptions.length; n++) {
              if(subscriptionData.organization_user_licences[m].customizedOptions[n].valueType == 'BOOL' && subscriptionData.organization_user_licences[m].customizedOptions[n].value==true){
                this.sumBaseCost += parseFloat(subscriptionData.organization_user_licences[m].customizedOptions[n].price)
              }
              if(subscriptionData.organization_user_licences[m].customizedOptions[n].valueType == 'NUMERIC'){
                this.sumBaseCost += parseFloat(subscriptionData.organization_user_licences[m].customizedOptions[n].price)*parseFloat(subscriptionData.organization_user_licences[m].customizedOptions[n].value)
              }
          }
      }

      this.sumBaseCost = Math.round(this.sumBaseCost*100)/100


      var sliceMin = 0
      var sliceMax = 0
      var slicePourcentage = 0
      
      this.sumRebate = 0
      var actualChart = this.organizationModel.subscription.data.organization_plan_description.rebateChartData.chart

      for (var m = 0; m < actualChart.length; m++) {
        var sliceMin = parseFloat(actualChart[m].priceSliceMin)
        var sliceMax = parseFloat(actualChart[m].priceSliceMax)
        var slicePourcentage = parseFloat(actualChart[m].pourcentageReduction)/100

        //Computation on base cost which include device in base cost
        if(this.sumBaseCost>sliceMax){
          this.sumRebate += (sliceMax-sliceMin)*slicePourcentage
        }
        if(this.sumBaseCost >= sliceMin && this.sumBaseCost < sliceMax){
          this.sumRebate += (this.sumBaseCost-sliceMin)*slicePourcentage
        }
        if(m == (actualChart.length-1) && this.sumBaseCost > sliceMax){
          this.sumRebate += (this.sumBaseCost-sliceMax)*slicePourcentage
        }

      }

      this.specialRebateString = ""
      this.specialRebate = 0
      var actualSpecialRebate = this.organizationModel.subscription.data.organization_special_rebate
      for (var m = 0; m < actualSpecialRebate.length; m++) {
        
        this.specialRebateString = this.specialRebateString +"( " + actualSpecialRebate[m].RebateBillingDescription[this.actualLanguage]

        if(actualSpecialRebate[m].RebateType=='Fix'){
          this.specialRebateString = this.specialRebateString + ":" + actualSpecialRebate[m].RebateAmount + "$"
          this.specialRebate = this.specialRebate + parseFloat(actualSpecialRebate[m].RebateAmount)
        }
        if(actualSpecialRebate[m].RebateType=='Pourcentage'){
          this.specialRebateString = this.specialRebateString + ":" + actualSpecialRebate[m].RebateAmount + "%"
          this.specialRebate = this.specialRebate + parseFloat(actualSpecialRebate[m].RebateAmount)*this.sumBaseCost/100
        }
        this.specialRebateString = this.specialRebateString + ", expire :"+actualSpecialRebate[m].ExpiringDate
        this.specialRebateString = this.specialRebateString + " )"
      }


      this.specialRebate = Math.round(this.specialRebate*100)/100
      this.sumFinalCost = this.sumBaseCost-this.sumRebate-this.specialRebate
      this.sumRebate = Math.round(this.sumRebate*100)/100
      this.sumFinalCost = Math.round(this.sumFinalCost*100)/100
      if(this.sumFinalCost<0){this.sumFinalCost = 0}
      
    },





  },

  mounted() {
    //Retirer l'inversion puisque le composant PortGraph effectue l'inversion sur la variable 
    //this.tableData = this.portData.reverse();
    //this.tableData = this.portData;


    //To be able to modify Organization plan and manage licence attribution, the user
    //needs to have a Administrator licence. Administrator licence is detected when
    //the user licence permission ['user'] as all its element equal to True
    var userLicenceLength = this.profileData.licences.length
    this.flagUserAsAdministratorLicence = true

    //Next code to be determine:
    /*
    if (userLicenceLength>0){
        var userPermissions = this.profileData.licences[userLicenceLength-1].permissions.user
        if(userPermissions[0].value & userPermissions[1].value & userPermissions[2].value){
          this.flagUserAsAdministratorLicence = true
        }

    }
    */


    if(localStorage.language){this.actualLanguage =  localStorage.language}
      else{this.actualLanguage = 'FR'}

  },

  

}
</script>

<style lang="css">
  .h1 {font-size: 24px;}
  .h2 {font-size: 20px;}
  .h3 {font-size: 16px;}
  .h4 {font-size: 14px;}
  .h5 {font-size: 12px;}

  /* Media Query pour les écrans de moins de 600px de large */
  @media (max-width: 600px) {
      .h1 {font-size: 18px;}
      .h2 {font-size: 16px;}
      .h3 {font-size: 14px;}
      .h4 {font-size: 10px;}
      .h5 {font-size: 8px;}
  }

</style>



// WEBPACK FOOTER //
// OrganizationDisplay.vue?61573dfd